import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { FC } from "react";
import { Box, HStack, Text } from "shared/components/Spor";
import { formatDateString } from "shared/utils/dateTimeUtils";
import { useTheme } from "styled-components";

interface Props {
  timestamp: string;
  message: string | null;
  source?: string | null;
  fallbackSource: string;
  hideDashedLine?: boolean;
}

export const LogEntry: FC<Props> = ({
  timestamp,
  message,
  source,
  fallbackSource,
  hideDashedLine = false,
}) => {
  const theme = useTheme();
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        backgroundColor={theme.colorBackgroundTertiary}
        p={2}
        borderRadius="xs"
        gap={1}
      >
        <HStack gap={0} justifyContent="space-between" alignItems="baseline">
          <HStack gap={1}>
            <Text fontWeight="400" variant="sm">
              {formatDateString(timestamp, "HH:mm")}
            </Text>

            <Text fontWeight="400" variant="sm" color="text.subtle">
              ({formatDateString(timestamp, "dd.MM.yy")})
            </Text>
          </HStack>

          <Text fontWeight="400" variant="sm" color="text.subtle">
            {source ?? fallbackSource}
          </Text>
        </HStack>

        <Text variant="sm">{message}</Text>
      </Box>
      {!hideDashedLine && <DashedLine variant="tertiary" />}
    </>
  );
};
